"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class NewPasswordForm extends _react.default.Component {
  render() {
    const {
      onSubmit,
      onChange,
      onValid,
      passwordRules,
      state,
      error
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: onSubmit
    }, error && /*#__PURE__*/_react.default.createElement("div", {
      className: "alert alert-danger",
      role: "alert"
    }, error.message), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-row mt-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted text-uppercase"
    }, /*#__PURE__*/_react.default.createElement("small", null, "New Password")), /*#__PURE__*/_react.default.createElement(_.PasswordStrength, {
      onInputChange: onChange,
      onPasswordValidate: onValid,
      rules: passwordRules
    }, /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
      type: 'password',
      id: 'password',
      name: 'password',
      value: state.password,
      onChange: this.onInputChange,
      required: true
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col mt-3"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: 'btn btn-primary',
      type: "submit"
    }, "Create"))));
  }
}
var _default = exports.default = NewPasswordForm;
module.exports = exports.default;